import { QueryClient } from '@tanstack/react-query';
import { WatcherrError, WatcherrNetworkError } from '@ixicare/resources';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount: number, error: WatcherrError) => {
        if (failureCount < 3 && error instanceof WatcherrNetworkError) {
          return true;
        }
        return false;
      },
    },
  },
});
